import Image from 'next/image';
// styles
import styles from './NotResults.module.css';

const NotResults = () => {
    return (
        <div className={styles['wrapper']}>
            <Image
                src={'/assets/images/product_not_found.svg'}
                alt={'not results image'}
                draggable={false}
                width={100}
                height={100}
            />
            <p className={styles['text']}>No se encontraron resultados</p>
        </div>
    );
};

export default NotResults;
